import $ from "jquery";

const ACTIVE_CLASS = "show";
const PREVENT_SCROLL_CLASS = "prevent-scroll";
const VIDEO_BLOCK_SELECTOR = ".video-embed-block";
const PLAYER_SELECTOR = ".video-embed-block__player";
const VIDEO_PLAY_TRIGGER_SELECTOR = "[data-video-trigger]";
const VIDEO_STOP_TRIGGER_SELECTOR = "[data-video-close-trigger]";

export class VideoModule {
    constructor() {
        this.scrollPos = 0;
        this.setupEvents();
    }

    setupEvents() {
        $("body").on("click", VIDEO_PLAY_TRIGGER_SELECTOR, ev => {
            const $target = $(ev.currentTarget);
            const $parent = $target.closest(VIDEO_BLOCK_SELECTOR);
            const $videoPlayer = $parent.find(PLAYER_SELECTOR);

            this.showVideo($videoPlayer);
        });

        $("body").on("click", VIDEO_STOP_TRIGGER_SELECTOR, ev => {
            const $target = $(ev.currentTarget);
            const $parent = $target.closest(VIDEO_BLOCK_SELECTOR);
            const $videoPlayer = $parent.find(PLAYER_SELECTOR);

            this.closeVideo($videoPlayer);
        });
    }

    showVideo($player) {
        this.scrollPos = $(document).scrollTop();

        $player.addClass(ACTIVE_CLASS);
        $("body").addClass(PREVENT_SCROLL_CLASS);
    }

    closeVideo($player) {
        $player.removeClass(ACTIVE_CLASS);
        $player.replaceWith($player.prop("outerHTML"));

        $("body").removeClass(PREVENT_SCROLL_CLASS);

        if (this.scrollPos) {
            $(document).scrollTop(this.scrollPos);
        }
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/front/App/VideoModule.js